import type { HelpFile } from '../../types/help'
import { SapSfEcInboundConfigEditDialogTestIds } from '../../../testids/SapSfEcInboundConfigEditDialogTestIds'

export const sapSfEcInboundConfigEditDialogHelp: HelpFile = {
  docPage: '/docs/connectors/sap-sf-ec-connector',
  texts: {
    [SapSfEcInboundConfigEditDialogTestIds.btnCancelSapSfEcConfig]: null,
    [SapSfEcInboundConfigEditDialogTestIds.btnSaveSapSfEcConfig]: null,
    [SapSfEcInboundConfigEditDialogTestIds.selectSapSfEcAuthType]:
      'Authentifizierungsverfahren. OAUTH2_CLIENT für direkt durch SuccessFactors ausgestellte Client-Credentials; OAUTH2_SAML_BEARER (RFC 7522), wenn der Mandant durch IAS oder einen anderen SAML-IdP vorgeschaltet ist.',
    [SapSfEcInboundConfigEditDialogTestIds.selectSapSfEcDatetimeFormat]:
      'Zeitstempel-Format, das der SF-EC-Mandant zurückgibt. ISO_8601 ist die kanonische Form; EPOCH_MS die ältere /OData(/Date(...))/-Hülle, die in einigen Bestandsmandanten noch vorkommt.',
  },
}
